import { render, staticRenderFns } from "./majorAudit.vue?vue&type=template&id=6677f930"
import script from "./majorAudit.vue?vue&type=script&lang=js"
export * from "./majorAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports